import {requestMessage} from '@/utils/request.js'

export function getTokenByUsername(data) {
  return requestMessage({
    url: `/im/getTokenByUsername`,
    method: 'post',
    data
  });
}

export function systemMessagePushGetSystemMessage(data) {
  return requestMessage({
    url: `/systemMessagePush/getSystemMessage`,
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/im.js